import React from "react";

import * as go from 'gojs';
import { ReactDiagram } from 'gojs-react';

import Card from 'react-bootstrap/Card';
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import { Calendar } from 'primereact/calendar';

import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { RiskLevels, ConsequenceLevels, ProbabilityLevels } from './RiskLevels'

class RiskHeatmap extends React.Component {

	state = {
        minDate: new Date(),
        history: -1,
        historyDate: new Date(),
    };

    constructor(props) {
        super(props);
        this.makeHeatCubes()
        this.diagramRef = React.createRef();
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.heatMapRisk !== this.props.heatMapRisk) {

            const heatMapRisk = this.props.heatMapRisk;

            if (heatMapRisk.riskID !== 0) {
                this.setupHistory(heatMapRisk.riskHistory);
                this.setHeatmapData();
            }
        } 
        if (prevState.history !== this.state.history) {
            this.setHeatmapData();
        }
    }

    setupHistory(riskHistory) {
        if (riskHistory.length > 0) {
            this.setState({ minDate: riskHistory[0].date });
            this.setState({ history: 0 });
            this.setState({ historyDate: riskHistory[0].date });
        }
    }

    setHeatmapData() {
        const risk = this.props.heatMapRisk;

        if (!this.diagramRef.current) return;
        const diagram = this.diagramRef.current.getDiagram();

        var nodes = [...this.riskCubes];
        var links = [];
        if (risk.riskID !== 0) {
            nodes.push({ key: risk.riskID, category: "risk", loc: this.riskLocation(risk.probability, risk.consequence), fill: "#FFFFFF", label: risk.name, value: risk.consequence * risk.probability });

            if (risk.consequenceAfter !== 0 && risk.probabilityAfter !== 0 && (risk.consequenceAfter !== risk.consequence || risk.probabilityAfter !== risk.probability) ) {
                nodes.push({ key: risk.riskID + 'm', category: "riskMitigated", loc: this.riskLocation(risk.probabilityAfter, risk.consequenceAfter), fill: "#FFFFFF", label: risk.riskName, value: risk.consequenceAfter * risk.probabilityAfter });
                links.push({ from: risk.riskID, to: risk.riskID + 'm' });
            }

            if (this.state.history >= 0 && risk.riskHistory.length > 0) { 
                const history = risk.riskHistory[this.state.history];
                if (history.consequence !== risk.consequence || history.probability !== risk.probability) {
                    nodes.push({ key: risk.riskID + 'h', category: "riskMitigated", loc: this.riskLocation(history.probability, history.consequence), fill: "#FFFFFF", label: risk.riskName, value: history.consequence * history.probability });
                    links.push({ from: risk.riskID + 'h', to: risk.riskID });
                }
            }
        }
        diagram.model = new go.GraphLinksModel(nodes, links);
    }


    riskLocation(prob, cons) {
        const x = prob * 100 - 50;
        const y = (5 - cons) * 100 + 50;

        return '' + x + ', ' + y;
    }

    makeHeatCubes() {
        const cols = RiskLevels[0].length
        const rows = RiskLevels.length
        const numOfCubes = cols * rows;
        var riskCubes = [];
        for (let i = 0; i < numOfCubes; i++) {
            const x = Math.trunc(i / cols);
            const y = i - x * cols;
            const location = y*100 + ", " + (4-x)*100;
            
            riskCubes[i] = {
                key: i+'cube', category: "background", loc: location, fill: RiskLevels[x][y].bgColor, label: RiskLevels[x][y].label, value: RiskLevels[x][y].value };
        }
        this.riskCubes = riskCubes;
    }

    initDiagram() {
        const $ = go.GraphObject.make;

        go.Diagram.licenseKey = "73f944e0b16331b700ca0d2b113f69ed1bb37a669e821ff55e5941a1ef0068432b99ec7903d78e92d4ff5cec1c2990d1ddcc3a79c34b076be335dadb46e58ef1b63575e214584286a70576c19dfe7df4ff7976a7cabc25f0db78dff1efa0d18c5abda3d248985eba3b680530557eb04ab6e4da78";

        const diagram = $(go.Diagram,
            {
                initialPosition: new go.Point(0, 0),
                //isReadOnly: true, 
                initialContentAlignment: go.Spot.TopLeft,
                allowHorizontalScroll: false,
                allowVerticalScroll: false, 
                allowZoom: false,
                padding: 10,
            }

        );
      
        diagram.nodeTemplateMap.add("background",
            $(go.Node, "Auto",
                {
                    height: 100,
                    width: 100,
                    selectable: false,
                    layerName: "Background",
                },
                new go.Binding("location", "loc", go.Point.parse),
                $(go.Shape,
                    "Rectangle",
                    {
                        stroke: "white",
                        fill: "#FFE4A0",
                    },
                    new go.Binding("fill", "fill"),
                ),
                {
                toolTip:  // define a tooltip for each node that displays the color as text
                    $("ToolTip",
                        $(go.TextBlock, { margin: 4 },
                            new go.Binding("text", "label"))
                    )  // end of Adornment
                },
            )           
        );

        diagram.nodeTemplateMap.add("risk",
            $(go.Node, "Auto",
                {
                    locationSpot: go.Spot.Center,
                    height: 40,
                    width: 40,
                    selectable: false,
                },
                new go.Binding("location", "loc", go.Point.parse),
                $(go.Shape,
                    "Ellipse",
                    {
                        stroke: "white",
                        fill: "rgba(0, 0, 0, 0.5)",
                    },
                )
            )
        );

        diagram.nodeTemplateMap.add("riskMitigated",
            $(go.Node, "Auto",
                {
                    locationSpot: go.Spot.Center,
                    height: 40,
                    width: 40,
                    selectable: false,
                },
                new go.Binding("location", "loc", go.Point.parse),
                $(go.Shape,
                    "Ellipse",
                    {
                        stroke: "white",
                        fill: "rgba(255, 255, 255, 0.5)",
                    },
                )
            )
        );

        diagram.nodeTemplateMap.add("riskHistory",
            $(go.Node, "Auto",
                {
                    locationSpot: go.Spot.Center,
                    height: 40,
                    width: 40,
                    selectable: false,
                },
                new go.Binding("location", "loc", go.Point.parse),
                $(go.Shape,
                    "Ellipse",
                    {
                        stroke: "white",
                        fill: "rgba(255, 255, 255, 0.5)",
                    },
                )
            )
        );

        diagram.add( 
            $(go.Part, "Graduated",
                { layerName: "Grid", position: new go.Point(0, 500), graduatedMin: 0, graduatedMax: 500, graduatedTickUnit: 100 },
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 H500" }),
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 V10" }),
                $(go.TextBlock,
                    {
                        font: "9pt sans-serif",
                        alignmentFocus: new go.Spot(0, 0, -2, 0),
                        textAlign: "center",
                        stroke: "gray",
                        segmentOffset: new go.Point(7, 7),
                        graduatedFunction: function (v) {
                            return v > 400 ? null : ProbabilityLevels[Math.trunc(v / 100)].text;
                        }
                    }
                )
            ));


        diagram.add(
            $(go.Part, "Graduated",
                { layerName: "Foreground", position: new go.Point(-20, 0), graduatedMin: 0, graduatedMax: 500, graduatedTickUnit: 100 },
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 V500" }),
                $(go.Shape, { stroke: "Gray", geometryString: "M0 0 L0 10" }),
                $(go.TextBlock,
                    {
                        font: "9pt sans-serif",
                        alignmentFocus: new go.Spot(0, 0, -2, 0),
                        textAlign: "center",
                        stroke: "gray",
                        segmentOffset: new go.Point(7, 7),
                        angle:90,
                        graduatedFunction: function (v) {
                            return v > 400 ? null : ConsequenceLevels[4-Math.trunc(v / 100)].text;
                        }
                    }
                )
            ));

        diagram.model = new go.GraphLinksModel(this.riskCubes);

        diagram.addDiagramListener("ViewportBoundsChanged", (e) => {
            diagram.zoomToRect(diagram.documentBounds);
        });

        diagram.addDiagramListener('InitialLayoutCompleted', (e) => {
            diagram.zoomToRect(diagram.documentBounds); 
        });

        return diagram;
    }

    onDateChange(e) {
        var checkDate = new Date(e.value);
        checkDate.setDate(checkDate.getDate() + 1);
        
        this.setState({ historyDate: new Date(e.value) });

        const historyList = this.props.heatMapRisk.riskHistory;
        var index = 0;

        historyList.forEach((history, i) => { if (history.date.getTime() < checkDate.getTime()) index = i });
        this.setState({ history: index});
    }

    historyPopup() {
        return (
            <Popover id="popover-basic" className="popup-menu shadow " style={{ maxWidth: '600px', width: 'auto' } }>
                <Popover.Body>
                    <Calendar value={this.state.historyDate} onChange={(e) => { this.onDateChange(e); document.body.click(); }} dateFormat="yy-mm-dd" inline maxDate={new Date()} minDate={this.state.minDate} />
                </Popover.Body>
            </Popover>
        );

    }

	render() {

		return (
            <Card className='rounded' style={{ minWidth: '30rem'}}>
                <Card.Header>
                    <div style={{ float: 'left' }}>
                        <b>Heat map</b>
                    </div>
                    <div style={{ float: 'right' }}>
                        <OverlayTrigger trigger="click" rootClose placement='left' overlay={this.historyPopup()}>
                            <Button size='sm' onClick={() => { }} id={"btn_add"} variant="secondary" disabled={false}><FontAwesomeIcon icon={faClockRotateLeft} /></Button>
                        </OverlayTrigger>
                    </div>
                </Card.Header>
                <Card.Body style={{ padding: '0px', position: 'relative', aspectRatio: '1/1' }}> 
                    <ReactDiagram
                        ref={this.diagramRef}
                        initDiagram={this.initDiagram.bind(this)}
                        divClassName='diagram-component'
                    />
                </Card.Body>
            </Card>
		)
	}
}
export default RiskHeatmap;